import { apiFetch } from '@ami/react/core';
import { DealerGroupFilter } from './dealerGroupFilter';

const _baseEndPoint = 'dealer-groups';

export const PaymentTerms = Object.freeze({
  net10: { id: 'Net10', label: 'Net 10' },
  net15: { id: 'Net15', label: 'Net 15' },
  net30: { id: 'Net30', label: 'Net 30' },
  net45: { id: 'Net45', label: 'Net 45' },
  net60: { id: 'Net60', label: 'Net 60' },
  net90: { id: 'Net90', label: 'Net 90' },
  net180: { id: 'Net180', label: '6 Month Terms' },
  net240: { id: 'Net240', label: '8 Month Terms' },
  cod: { id: 'COD', label: 'Payable on Receipt' },
  prepay: { id: 'Prepay', label: 'Prepay' },
  toBeConfirmed: { id: 'ToBeConfirmed', label: 'To Be Confirmed' },
});

export class DealerGroup {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.isExpeditedShippingEnabled = item.isExpeditedShippingEnabled;
      this.isEmailCommunicationEnabled = item.isEmailCommunicationEnabled;
      this.isRestockingFeeEnabled = item.isRestockingFeeEnabled;
      this.isFreightSurchargeEnabled = item.isFreightSurchargeEnabled;
      this.imageKey = item.imageKey;
      this.imageUrl = item.imageUrl;
      this.discountPercentage = item.discountPercentage;
      this.paymentTerms = item.paymentTerms;
      this.msrpMarkupPercentage = item.msrpMarkupPercentage;
      this.isRetired = item.isRetired;
      return;
    }
    this.id = null;
    this.name = '';
    this.isExpeditedShippingEnabled = false;
    this.isEmailCommunicationEnabled = true;
    this.isRestockingFeeEnabled = true;
    this.isFreightSurchargeEnabled = true;
    this.imageKey = null;
    this.imageUrl = null;
    this.discountPercentage = 0;
    this.paymentTerms = PaymentTerms.toBeConfirmed.id;
    this.msrpMarkupPercentage = 0;
    this.isRetired = false;
  }

  static async search(filter = new DealerGroupFilter(), page) {
    const newFilter = new DealerGroupFilter(filter);
    if (newFilter.name) {
      newFilter.name = encodeURIComponent(newFilter.name);
    }

    newFilter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${newFilter.toQueryString()}`);
    return result.map((x) => new DealerGroup(x));
  }

  static getGroupOptions(params) {
    params = params || { name: '' };
    var queryString = Object.keys(params)
      .map((key) => key + '=' + params[key])
      .join('&');
    return apiFetch(`${_baseEndPoint}?${queryString}`).then((entities) =>
      Promise.resolve(
        entities.map((x) => ({
          id: x.id,
          label: x.name,
        }))
      )
    );
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new DealerGroup(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}
